<template>
    <div class="wrapper-style quiz-style rd-approach">
        <div class="fix-bg">
            <div class="bgview">
                <div class="inner-wave-bt"></div>
            </div>
        </div>
        <div class="page-box">
            <div class="bgview">
                <div class="header">
                    <div class="view">
                        <div class="left">
                            <div class="header-funnow-logo">
                                <div class="bgshow"></div>
                            </div>
                        </div>
                        <div class="header-event-logo">
                            <div class="bgshow"></div>
                        </div>
                    </div>
                </div>
                <div class="quiz-box">
                    <div class="loading"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import LottieAnimation from 'lottie-web-vue'
import {gsap} from "gsap";

export default {
    name:"Loading",
    props: ["path", "uid", "result"],
    components:{
        LottieAnimation
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted: function () {
        this.$gtag.event('view_loading_page')
        this.$emit('approach-animate')
        const _this = this
        setTimeout(function () {
            _this.$emit('switch-component', 'result-part')
        }, 3500)

        // 預載圖片
        const image = new Image();
        image.src = this.path+this.result.song.image_share+'.jpg'
        const image2 = new Image();
        image2.src = this.path+this.result.song.image_result+'.png'

    },
    watch: {
    }
}
</script>

